import React from 'react';
import classNames from 'classnames';

import Table from './Table';
import THead from './THead/THead';
import TRow from './TRow/TRow';
import THeader from './THeader/THeader';
import TBody from './TBody/TBody';
import TData from './TData/TData';

// TODO - icons
// import ArrowUpIcon from './arrow_upward-black-24dp.svg';
import { ReactComponent as ArrowUpIcon } from './arrow_upward-black-18dp.svg';
import styles from './SortableTable.module.scss';

// const headCells = [
//   { id: 'name', sortable: false, label: 'Dessert (100g serving)' },
//   { id: 'calories', sortable: true, label: 'Calories' },
//   { id: 'fat', sortable: true, label: 'Fat (g)' },
//   { id: 'carbs', sortable: true, label: 'Carbs (g)' },
//   { id: 'protein', sortable: true, label: 'Protein (g)' },
// ];
// const headCellsExample = [
//   {
//     id: 'id',
//     label: '№',
//     sortable: true,
//     // valueField: 'id' | null,
//     // renderValue: (item: any, index: number) => index,
//     // renderValue: (item: any) => item.id,
//     // maxWidth: '160px',
//   },
//   {
//     id: 'name',
//     label: 'Название',
//     sortable: false,
//   },
//   {
//     id: 'created_at',
//     label: 'Дата',
//     sortable: true,
//     renderValue: (record: any, index: number) => record.created_at.toString(),
//   },
//   {
//     id: 'status',
//     label: 'Статус',
//     sortable: true,
//   },
//   {
//     id: 'actions',
//     label: '',
//     sortable: false,
//   },
// ];

// const dataExample = [
//   {
//     id: 2,
//     number: '00001-20200429',
//     created_at: '2020-04-29T12:54:30+0300',
//     // product_code: 'L2',
//     // srs_name: 'wgs84',
//     // bytes_per_pixel: 1,
//     total_price: 37624,
//     // images: [],
//   },
// ];

// type SortOrder = 'ASC' | 'DESC';

interface ColumnSchema {
  id: string;
  label: string | JSX.Element;
  sortable?: boolean;
  renderValue?: (record: any, index: number) => string | JSX.Element;
  // innerProps?: React.HtmlHTMLAttributes<HTMLDivElement>;
  dataCellProps?: React.HtmlHTMLAttributes<HTMLTableDataCellElement>;
}

interface SortableTableProps {
  className?: string;
  columns: ColumnSchema[]; // headCells
  records: any[]; // data
  activeRecordIds?: string[];
  // sort?: string; // '-date'
  sorting: { field: string; direction: 'ASC' | 'DESC' };
  onRequestSort?: (field: string, direction: 'ASC' | 'DESC') => void;
  onRowSelect?: (record: any) => void;
}

// const getHeaderSortClasses = (sort: string, itemId: string) => {
//   let sortField, sortDir;
// const parseSort = (sort: string | undefined | null) => {
//   let sortField;
//   let sortDir;

//   if (sort === null || sort === undefined) {
//     return {};
//   }

//   if (sort.startsWith('-')) {
//     sortField = sort.substring(1);
//     sortDir = 'DESC';
//   } else {
//     sortField = sort;
//     sortDir = 'ASC';
//   }

//   return { sortField, sortDir };
// };

const SortableTable: React.FC<SortableTableProps> = props => {
  const {
    className,
    columns,
    records,
    sorting,
    activeRecordIds,
    onRequestSort,
    onRowSelect,
  } = props;
  // const [sort, setSort] = useState<string | null>(null); // sorted by field (m.b. array)
  // const [sort, setSort] = useState({ field: '', dir: 'ASC' });
  // const [activeRecordIdsState, setActiveRecordIds] = useState<string[]>([]);
  const { field: sortField, direction: sortDir } = sorting;

  // TODO - useCallback
  const handleSortRequest = (cell: ColumnSchema) => {
    // onRequestSort &&
    if (cell.sortable) {
      const direction = sortDir === 'DESC' || sortField !== cell.id ? 'ASC' : 'DESC';
      if (onRequestSort !== undefined) {
        onRequestSort(cell.id, direction);
      }
      // setSort({
      //   field: cell.id,
      //   dir: direction,
      // });
    }
  };

  const handleRowClick = (record: any) => {
    if (onRowSelect !== undefined) {
      onRowSelect(record);
    }
  };

  const getIsActiveRow = (record: any) => {
    if (Array.isArray(activeRecordIds)) {
      return activeRecordIds.indexOf(record.id) > -1;
    } else {
      return false;
    }
  };

  console.log(sorting);

  return (
    <Table className={className}>
      <THead>
        <TRow>
          {columns.map(headCell => (
            <THeader key={headCell.id}>
              <div
                className={classNames(styles.headerCell, {
                  [styles.sortableHeaderCell]: headCell.sortable === true,
                  [styles.sortedHeaderCell]: sortField === headCell.id,
                  'sort-direction--desc': sortDir === 'ASC',
                  'sort-direction--asc': sortDir === 'DESC',
                  // [styles.headerCellSortedUp]: sortField === headCell.id,
                  // 'sort-direction-up':
                })}
                onClick={() => handleSortRequest(headCell)}
              >
                <span>{headCell.label}</span>
                {headCell.sortable === true && (
                  <span className={styles.sortIcon}>
                    <ArrowUpIcon />
                  </span>
                )}
              </div>
            </THeader>
          ))}
        </TRow>
      </THead>
      <TBody>
        {records.map((record, index) => (
          <TRow
            key={record.id || index}
            className={classNames({ active: getIsActiveRow(record) })}
            onClick={() => handleRowClick(record)}
          >
            {columns.map(headCell => {
              const cellContent =
                headCell.renderValue !== undefined
                  ? headCell.renderValue(record, index)
                  : record[headCell.id];
              return (
                <TData key={headCell.id} {...headCell.dataCellProps}>
                  {/* <div {...headCell.innerProps}>{cellContent}</div> */}
                  {cellContent}
                </TData>
              );
            })}
          </TRow>
        ))}
      </TBody>
    </Table>
  );
};

export default SortableTable;
